function storeinfo(){
	
  var storename = "Bernard's Jewelers";
  var phone1 = "(912) 764-5379";
  var phone2 = "";
  var email = "bernardsjewelers@outlook.com";
  
  var storeaddress = `23999 Hwy 80 E.`;
  var city = `Statesboro`;
  var state = `Georgia`;
  var zip = `30461`;
  var region =`United States`;
         
  var storehours = `Mon - Fri: 9:00am - 5:45pm<br>
Sat: 9:00am - 2:45pm<br>
Closed Sunday`;
  
  var newdate = new Date();
  var Establishedyear = newdate.getFullYear() - 1969;
  var currentyear = newdate.getFullYear();
  var storenameurl = window.location.origin;
  var address = ` ${storeaddress} <br> ${city}, ${state} ${zip} `

  var Xstorename = document.getElementsByClassName("storename");
  for(var i=0; i< Xstorename.length; i++){
    Xstorename[i].innerHTML = storename;
    if(Xstorename[i].nodeName == 'A'){
      Xstorename[i].setAttribute('href', storenameurl);
    }
  }

  var Xcurrentyear = document.getElementsByClassName("currentyear");
  for(var i=0; i< Xcurrentyear.length; i++){
    Xcurrentyear[i].innerHTML = currentyear;
  }
  
  var Xphone1 = document.getElementsByClassName("phone1");
  for(var i=0; i< Xphone1.length; i++){
    Xphone1[i].innerHTML = phone1;
    if(Xphone1[i].nodeName == 'A'){
      Xphone1[i].setAttribute('href',`tel:${phone1}`);
    }
  }
  var Xphone2 = document.getElementsByClassName("phone2");
  for(var i=0; i< Xphone2.length; i++){
    Xphone2[i].innerHTML = phone2;
    if(Xphone2[i].nodeName == 'A'){
      Xphone2[i].setAttribute('href',`tel:${phone2}`);
    }
  }

  var Xemail = document.getElementsByClassName("email");
  for(var i=0; i< Xemail.length; i++){
    Xemail[i].innerHTML = email;
    if(Xemail[i].nodeName == 'A'){
      Xemail[i].setAttribute('href',`mailto:${email}`);
    }
  }
  var Xaddress = document.getElementsByClassName("address");
  for(var i=0; i< Xaddress.length; i++){
    Xaddress[i].innerHTML = address;
  }
  var Xstoreaddress = document.getElementsByClassName("storeaddress");
  for(var i=0; i< Xstoreaddress.length; i++){
    Xstoreaddress[i].innerHTML = storeaddress;
  }
  var Xcity = document.getElementsByClassName("city");
  for(var i=0; i< Xcity.length; i++){
    Xcity[i].innerHTML = city;
  }
  var Xstate = document.getElementsByClassName("state");
  for(var i=0; i< Xstate.length; i++){
    Xstate[i].innerHTML = state;
  }
  var Xzip = document.getElementsByClassName("zip");
  for(var i=0; i< Xzip.length; i++){
    Xzip[i].innerHTML = zip;
  }
  var Xstorehours = document.getElementsByClassName("storehours");
  for(var i=0; i< Xstorehours.length; i++){
    Xstorehours[i].innerHTML = storehours;
  }
  var Xregion = document.getElementsByClassName("region");
  for(var i=0; i< Xregion.length; i++){
    Xregion[i].innerHTML = region;
  }
  var XEstablishedyear = document.getElementsByClassName("Establishedyear");
  for(var i=0; i< XEstablishedyear.length; i++){
    XEstablishedyear[i].innerHTML = Establishedyear;
  }
}

$(window).on('load', function(){
	storeinfo(); 
  	$(".HL-ColLeft, .HL-ColRight").click(function(){
    storeinfo() 
  });


});


